import { domThemeAdapter } from './adapters/dom-theme'
import type { ThemePort } from './domain/theme'

const themePort: ThemePort = domThemeAdapter

export { themePort }
